@import '../../theme/colors';

.root {
  min-height: 100%;
  display: flex;
  flex-direction: column;
}

.header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

.paper {
  display: flex;
  flex: 1;
}

.sidebar {
  border-right: 1px solid $lightGrey;
}

.content {
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow-x: hidden;
}

.tableHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 30px 30px 0 38px;
}

.titleContainer {
  display: flex;
  align-items: center;
}

.tableTitle {
  color: $neutral-600;
  font-family: var(--font-family__heading);
  font-weight: 600;
  font-size: 16px;
  margin: 0;
  margin-right: 8px;
}

.tableWrapper {
  overflow: auto;
  width: 100%;
  flex: 1;
}

.table {
  margin-top: 20px;
}

.tableLink {
  text-decoration: none;
  color: $oceanBlue;
}

.lastModifiedColumn {
  white-space: nowrap;
}

.loading {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.error {
  flex: 1;
  padding: 30px;
}

.paginationFooter {
  padding: 12px 30px 12px 38px;
  border-top: 1px solid $lightGrey;
}

.circularProgressContainer {
  display: flex;
  justify-content: center;
}

.menu {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: wrap;
  width: 100%;
  border-bottom: 2px solid $lighterGrey;
  margin: 0;
  padding: 0;
  list-style: none;

  a {
    box-sizing: content-box;
    color: $neutral-600;
    position: relative;
    top: 4px;
    padding: 10px;
    border-bottom: 4px solid transparent;
    text-decoration: none;
    font-weight: 400;
    &:not(:last-of-type) {
      margin-right: 20px;
    }
    .menuItem {
      margin: 0;
      padding: 0;
      font-family: var(--font-family__heading);
      font-size: 16px;
      white-space: nowrap;
    }
  }
  .current {
    font-weight: 600;
    border-bottom: 4px solid $oceanBlue;
  }
}
